// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/views/jobs/searches/SearchPager.js
//
// Pagination minimale (précédent / suivant + « Page x sur y ») des listes de recherches.

import React from 'react'
import { useTranslation } from 'react-i18next'
import { CButton } from '@coreui/react'
import './searches.scss'

const SearchPager = ({ pagination, onPage }) => {
  const { t } = useTranslation()
  if (!pagination || pagination.totalPages <= 1) return null
  const { page, totalPages } = pagination
  return (
    <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
      <CButton size="sm" color="light" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        ‹
      </CButton>
      <span className="small text-medium-emphasis">
        {t('searches:list.page', { page, total: totalPages })}
      </span>
      <CButton
        size="sm"
        color="light"
        disabled={page >= totalPages}
        onClick={() => onPage(page + 1)}
      >
        ›
      </CButton>
    </div>
  )
}

export default SearchPager
